<template>
  <div>

    <ketones-line-graph
      class="insetGraph"
      v-if="$store.state.user.scope"
      :userId="$store.state.user.scope.user_id"
    ></ketones-line-graph>

    <mu-row gutter v-if="$store.state.user.scope" class="content">
      <mu-col desktop="30" tablet="50" width="100">
        <ketones-input
          style="margin-top: 24px"
          class="card-spacing bottom"
          :blood-glucose="$store.state.user.settings.blood_glucose"
        />

        <tracking-exporter
          type="ketones">
        </tracking-exporter>

        <tracking-notifier
          v-if="$store.state.user.scope"
          :userId="$store.state.user.scope.user_id"
        ></tracking-notifier>
      </mu-col>
      <mu-col desktop="70" tablet="50">
        <mu-card
          style="margin-top: 24px;"
          id="blood-glucose-data"
          class="tracking-data"
        >
          <mu-card-text>
            <p class="tracking-subtext" v-text="$t('message.trackingHelpText')"></p>
          </mu-card-text>
          <mu-timeline>
            <div v-for="group, groupKey in groupFilter()" :key="'group-key-' + groupKey" style="margin-bottom: 16px;">
              <div v-for="titleItem, titleIndex in group" v-if="titleIndex === 0" class="timelineSpacing">
                <div class="bold timelineTitle"
                     v-text="groupedDateFormat(titleItem.date_created)">
                </div>
              </div>
              <div v-for="item, index in group" class="timelineSpacing" :key="'tracking-timeline-item-' + index"
                   v-bind:class="{notEditMode: !item.isEditMode}">
                <mu-timeline-item
                  :iconColor="btnColor"
                  iconLine="8"
                  iconType="solid"
                  @click.native="showItemControls(item)"
                >
                  <mu-row>
                    <mu-col>
                      <div class="trackingDate" v-if="!item.isEditMode"
                           v-text="groupedItemDate(item.date_created)"></div>
                    </mu-col>
                    <mu-col>
                      <div v-if="!item.isEditMode" v-bind:class="{spacingBottom: item.isControlsVisible}"
                           class="reading"
                           v-text="$store.state.user.settings.blood_glucose.measure === 'mmoll' ? '' +item.mmoll + ' mmol/L' :  item.mgdl + ' mg/dL'"></div>
                    </mu-col>
                  </mu-row>
                  <div v-if="item.isControlsVisible && !item.isEditMode" align="right">
                    <mu-flat-button
                      :color="btnColor"
                      :label="$t('message.editText')"
                      icon="edit"
                      @click.native="editReading(item)"
                    >
                    </mu-flat-button>
                    <mu-flat-button
                      :color="btnColor"
                      :label="$t('message.deleteText')"
                      icon="delete"
                      @click.native="deleteReading(item)"
                    ></mu-flat-button>
                  </div>
                  <div v-if="item.isEditMode">
                    <ketones-edit
                      @updateReading="updateReading"
                      @closeEditPanel="closeEditMode(item)"
                      :preference="$store.state.user.settings.blood_glucose.measure"
                      :item="item"
                    ></ketones-edit>
                  </div>
                </mu-timeline-item>
              </div>
            </div>
          </mu-timeline>
          <mu-card-text align=" center" v-if="isReadingsLoading">
            <mu-circular-progress color="#0179d5"></mu-circular-progress>
            <div>One sec...</div>
          </mu-card-text>
          <div v-if="!isReadingsLoading" ref="detector"></div>
        </mu-card>
      </mu-col>

    </mu-row>
  </div>
</template>
<script>

  import KetonesApi from '../../api/Tracking/Ketones'
  import TrackingDetailMixin from '../../mixins/TrackingDetailMixin'
  import KetonesLineGraph from "../../components/Tracking/Graphs/Ketones/LineGraph";
  import KetonesEdit from "../../components/Tracking/Edit/Ketones/KetonesEdit";
  import TrackingNotifier from "../../components/TrackingNotifier/TrackingNotifier.vue";
  import TrackingExporter from "../../components/Tracking/Exporter/Exporter.vue";

  let fromDate = moment().subtract(1, 'month');
  let toDate = moment();

  export default {
    components: {
      TrackingExporter,
      TrackingNotifier,
      KetonesEdit,
      KetonesLineGraph
    },
    mixins: [TrackingDetailMixin],
    data() {
      return {
        btnColor: '#2761ff'
      }
    },
    mounted() {
      let self = this;
      self.$gtag.pageview('/tracking/ketones');
      self.$EventBus.$on('ketonesPusherReceived', function () {
        self.getData();
      });
      self.getData();
    },
    methods: {
      updateReading(item) {
        let self = this;
        let currentReading = self.data.data.filter(function (reading) {
          return item.progress_id === reading.progress_id
        })[0];
        currentReading.mgdl = item.mgdl;
        currentReading.mmoll = item.mmoll;
        currentReading.date_created = item.date_created;
        self.$EventBus.$emit('ketonesReadingUpdated');
        self.sortItems();
      },
      deleteReading(reading) {
        let self = this;
        let swal = self.$alert;
        self.$alert({
          title: self.$t('message.confirmRemoveTitle'),
          text: self.$t('message.confirmRemoveKetoneItem'),
          type: "warning",
          showCancelButton: true,
          showLoaderOnConfirm: false,
          confirmButtonColor: "white",
          cancelButtonColor: "white",
          preConfirm: function () {
            return KetonesApi.deleteKetonesTracking(reading.progress_id, reading.tracking_id)
          }
        })
          .then(function (response) {
            let index = self.data.data.indexOf(reading);
            self.data.data.splice(index, 1);
            self.$alert({
              title: self.$t('message.labelSuccess'),
              text: self.$t('message.confirmedRemoveKetoneItem'),
              type: "success",
              showCancelButton: false,
              confirmButtonColor: "white"
            })

          }.bind(self))
          .catch(self.$alert.noop)
      },
      getData() {
        let self = this;
        KetonesApi.getKetonesTrackingDetail(1, 15)
          .then(function (response) {
            self.data = response.data;
            self.isReadingsLoading = false;
          })
      },
      loadMoreData() {
        let self = this, page = self.data.page, pages = self.data.pages;
        if (page >= pages) {
          self.isReadingsLoading = false;
          return;
        }
        if ((page < pages)) {
          self.isReadingsLoading = true;
          page++;
          KetonesApi.getKetonesTrackingDetail(page, 15)
            .then(function (response) {
              self.data.page = response.data.page;
              self.data.data.push.apply(self.data.data, response.data.data);
              self.isReadingsLoading = false;
            })
        }
      },
    },
    beforeDestroy() {
      this.$EventBus.$off('ketonesReadingAdded');
      this.$EventBus.$off('ketonesPusherReceived');
    }
  }
</script>
<style lang="less" scoped>
  @import "./styles/trackingDetail.css";

  @bgBranding: #F5950C;

  .timelineSpacing {
    padding-top: 8px;
    padding-left: 16px;
    padding-right: 16px;
    padding-bottom: 0px;
  }

  .timelineSpacing.notEditMode:hover {
    background: fade(@bgBranding, 10) !important;
    cursor: pointer;
  }

  .whiteTitle {
    font-size: 18px !important;
    color: white !important;

  }
</style>



// WEBPACK FOOTER //
// Ketones.vue?7fd0285e